module.exports = __webpack_public_path__ + "img/product-atomizer-sopuria-ARYMI.71fb75e1.jpg";